// Spieler-Einstellungen (Barrierefreiheit, Darstellung) – lokal gespeichert.
import { writable } from 'svelte/store';

export interface Settings {
  fontScale: number; // 0.9 – 1.5
  colorblind: boolean;
  subtitles: boolean;
  reducedMotion: boolean;
}

const KEY = 'dlr.settings';
const defaults: Settings = { fontScale: 1, colorblind: false, subtitles: true, reducedMotion: false };

function load(): Settings {
  try {
    return { ...defaults, ...JSON.parse(localStorage.getItem(KEY) ?? '{}') };
  } catch {
    return { ...defaults };
  }
}

export const settings = writable<Settings>(load());

settings.subscribe((s) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* egal */
  }
  const r = document.documentElement;
  r.style.setProperty('--ui-scale', String(s.fontScale));
  r.dataset.cb = s.colorblind ? 'on' : 'off';
  r.dataset.motion = s.reducedMotion ? 'reduced' : 'full';
});
